import { darken } from '@mui/material';

export default function Button(theme: any) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px', // base rounded corners
          '&:hover': {
            boxShadow: 'none',
            borderRadius: '12px', // enforce rounding on hover
          },
          '&.Mui-disabled': {
            color: '#ffffff',
          },
        },
        sizeLarge: {
          height: 48,
          borderRadius: '12px', // consistent rounding for large buttons
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z12,
          borderRadius: '12px',
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '12px', // keep rounded
          },
        },
        containedPrimary: {
          // background: theme.palette.gradients.primary,
          background: 'linear-gradient(338.5deg, #B963FB 0.63%, #3681FB 100%)',
          color: theme.palette.primary.contrastText,
          boxShadow: theme.customShadows.primary,
          borderRadius: '12px',
          '&:hover': {
            // background:
            //   'linear-gradient(338.5deg, #A85CFA 0.63%, #2F73F7 100%)',
            background: `linear-gradient(
      338.5deg,
      ${darken('#B963FB', 0.1)} 0.63%,
      ${darken('#3681FB', 0.1)} 100%
    )`,
            opacity: 0.9,
            borderRadius: '12px', // keep rounded
          },
        },
        // containedSecondary: {
        //   background: theme.palette.gradients.secondary,
        //   color: theme.palette.secondary.contrastText,
        //   boxShadow: theme.customShadows.secondary,
        //   borderRadius: '12px',
        //   '&:hover': {
        //     background: theme.palette.gradients.secondary,
        //     opacity: 0.9,
        //     borderRadius: '12px', // keep rounded
        //   },
        // },
        // outlinedInherit: {
        //   border: `1px solid ${theme.palette.grey[500_32]}`,
        //   '&:hover': {
        //     backgroundColor: theme.palette.action.hover,
        //   },
        // },
        outlinedPrimary: {
          position: 'relative',
          borderRadius: 12,
          padding: '6px 16px',
          overflow: 'hidden',

          backgroundColor: '#fff',
          border: 'none',

          color: 'transparent',
          backgroundImage: theme.palette.gradients.primary,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',

          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          zIndex: 1,
          cursor: 'pointer',

          '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            color: 'inherit',
            display: 'inline-flex',
            '& svg': {
              fill: 'currentColor',
            },
          },

          // Gradient border using pseudo-element
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: 12,
            padding: 1,
            background: theme.palette.gradients.primary, // normal gradient border
            WebkitMask:
              'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'destination-out',
            maskComposite: 'exclude',
            pointerEvents: 'none',
            zIndex: -1,
            transition: 'background 0.3s ease', // smooth transition on hover
          },

          '&:hover': {
            backgroundColor: theme.palette.grey[900], // dark background
            color: theme.palette.primary.contrastText, // text visible on dark bg
            opacity: 1,
            border: 'none',
            boxShadow: 'none',
            cursor: 'pointer',

            '&::before': {
              background:
                theme.palette.gradients.primaryDark ||
                'linear-gradient(45deg, #5a00a8, #2e0054)', // darker gradient border on hover
            },
          },
        },

        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
            borderRadius: '12px', // keep rounded
          },
        },
      },
    },
  };
}
